import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import { DynamicPricingRBAC, DynamicPricingUpsertRBAC, DynamicPricingDetailRBAC } from './rbac'

const DynamicPricingTable = lazy(() => import('../pages/PricingTable'))
const DynamicPricingDetail = lazy(() => import('../pages/PricingDetail'))
const CreateEditPricing = lazy(() => import('../pages/CreateEditPricing'))

export const DynamicPricingTableRouter: RouterFeatureInterface<
  'DynamicPricingTableRouter',
  '/dashboard/dynamic-pricing'
> = {
  name: 'DynamicPricingTableRouter',
  Component: DynamicPricingTable,
  path: '/dashboard/dynamic-pricing',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: DynamicPricingRBAC.pageID,
}

export const CreateDynamicPricingRouter: RouterFeatureInterface<
  'CreateDynamicPricingRouter',
  '/dashboard/dynamic-pricing/create'
> = {
  name: 'CreateDynamicPricingRouter',
  Component: CreateEditPricing,
  path: '/dashboard/dynamic-pricing/create',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: DynamicPricingUpsertRBAC.pageID,
}

export const CreatedDynamicPricingRouter: RouterFeatureInterface<
  'CreatedDynamicPricingRouter',
  '/dashboard/dynamic-pricing/created/:id'
> = {
  name: 'CreatedDynamicPricingRouter',
  Component: CreateEditPricing,
  path: '/dashboard/dynamic-pricing/created/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: DynamicPricingUpsertRBAC.pageID,
}

export const EditDynamicPricingeRouter: RouterFeatureInterface<
  'EditDynamicPricingeRouter',
  '/dashboard/dynamic-pricing/edit/:id'
> = {
  name: 'EditDynamicPricingeRouter',
  Component: CreateEditPricing,
  path: '/dashboard/dynamic-pricing/edit/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: DynamicPricingUpsertRBAC.pageID,
}

export const DynamicPricingDetailRouter: RouterFeatureInterface<
  'DynamicPricingDetailRouter',
  '/dashboard/dynamic-pricing/detail/:id'
> = {
  name: 'DynamicPricingDetailRouter',
  Component: DynamicPricingDetail,
  path: '/dashboard/dynamic-pricing/detail/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: DynamicPricingDetailRBAC.pageID,
}

const DynamicPricingRouter = [
  DynamicPricingTableRouter,
  CreateDynamicPricingRouter,
  CreatedDynamicPricingRouter,
  EditDynamicPricingeRouter,
  DynamicPricingDetailRouter,
]

export const DynamicPricingRouterDetail = generateRouterDetail(DynamicPricingRouter)

export default DynamicPricingRouter
